import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from 'styled-components';
import AppContextProvider from './contextProviders/AppContext';
import Events from './containers/Events';
import { baseUrl } from './utils';
import './translations';
import theme from './styles/theme';
import Breadcrumbs from './components/Breadcrumbs';
import BookEvent from './containers/BookEvent/BookEvent';
import { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

const PageError = lazy(() => import('./components/PageError'));
const ErrorPage = lazy(() => import('./containers/ErrorPage'));
const Register = lazy(() => import('./containers/Register'));
const Success = lazy(() => import('./containers/Register/Success'));
const SelfCheckInEvent = lazy(
  () => import('./containers/BookEvent/SelfCheckInEvent')
);
const SelfCheckInThankYou = lazy(
  () => import('./containers/BookEvent/SelfCheckInThankYou')
);
const queryClient = new QueryClient();

function App() {
  console.log("Added log to test all markets deployment");
  return (
    <div className="full" data-css-scope>
      <ThemeProvider theme={theme}>
        <Router basename={baseUrl}>
          <Suspense fallback={<></>}>
            <AppContextProvider>
              <QueryClientProvider client={queryClient}>
                <Breadcrumbs />
                <PageError />
                <Switch>
                  <Route path="/error" component={ErrorPage} exact />
                  <Route path="/:storeName?" component={Events} exact />
                  <Route
                    path="/in/:eventid"
                    component={SelfCheckInEvent}
                    exact
                  />
                  <Route
                    path="/in/:eventid/thankyou"
                    component={SelfCheckInThankYou}
                    exact
                  />
                  <Route
                    path="/redirect/:eventid"
                    component={BookEvent}
                    exact
                  />
                  <Route
                    path="/:storeName/:eventid"
                    component={BookEvent}
                    exact
                  />
                  <Route
                    path="/:storeName/:eventid/register"
                    component={Register}
                    exact
                  />
                  <Route
                    path="/:storeName/:eventid/register/success"
                    component={Success}
                    exact
                  />
                  <Redirect exact push to="/" />
                </Switch>
              </QueryClientProvider>
            </AppContextProvider>
          </Suspense>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default Sentry.withProfiler(App);
